// extracted by mini-css-extract-plugin
export default {"root":"Db5Cn","favoriteIconActive":"wHuzR"};